export default function Minus() {
  return (
    <svg
      width="24"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="27" y1="13" x2="-1.90356e-08" y2="13" stroke="currentColor" />
    </svg>
  );
}
